// extracted by mini-css-extract-plugin
export default {"container":"AccountBalances_container__RvJ9G","table":"AccountBalances_table__ZNa0g","tbody":"AccountBalances_tbody__9a0Ef"};